import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f283081c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap-col-header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "wrap-col-header__title pt-3 xl:pt-0" }, "Resumen de Pagos", -1))
const _hoisted_3 = { class: "wrap-col-header__data-update" }
const _hoisted_4 = { class: "flex flex-col content-start" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = {
  href: "",
  ref: "iPhoneLink",
  rel: "noreferrer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_ProcessPayment = _resolveComponent("ProcessPayment")!
  const _component_LastPaymentDetail = _resolveComponent("LastPaymentDetail")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("span", _hoisted_3, " Última actualización " + _toDisplayString(_ctx.$filters.formatDate(_ctx.timestamp)), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_Loader, { showLoader: _ctx.isLoading }, null, 8, ["showLoader"]),
      _createElementVNode("div", null, [
        _createVNode(_component_ProcessPayment, { paymentProcess: _ctx.processData }, null, 8, ["paymentProcess"])
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_LastPaymentDetail)
      ]),
      _hoisted_5
    ]),
    _createElementVNode("a", _hoisted_6, null, 512)
  ], 64))
}